import {
  RESET_PASSWORD_REQUEST,
  RECOVER_PASSWORD_REQUEST,
  VERIFY_REQUEST,
  VERIFY_SUCCESS,
  REFRESH_WALLET_REQUEST,
  USER_PREMIUM_PLANS_REQUEST,
} from '../../constants/me';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
  resetPasswordRequest,
  recoverPasswordRequest,
  verifyRequest,
  getUserPremiumPlans,
} from '../../api/me';
import i18n from '../../i18n';

import {
  resetPasswordFailureAction,
  resetPasswordSuccessAction,
  recoverPasswordFailureAction,
  recoverPasswordSuccessAction,
  verifySuccessAction,
  refreshWalletSuccessAction,
  refreshWalletFailureAction,
  getUserPremiumPlansSuccessAction,
  getUserPremiumPlansFailureAction,
} from '../../store/me/actions';
import { toast } from 'react-toastify';
import { push } from 'react-router-redux';
import { refreshWallet } from '../../api/me';
import { RecoverPassword } from '../../components/RecoverPassword/RecoverPassword';

function* verifyRequestSaga(payload: any): any {
  try {
    const verify = yield call(verifyRequest, { token: payload.payload });
    if (!verify || !verify.access_token) {
      throw new Error('Error verifying');
    }
    yield put(verifySuccessAction(verify));
  } catch (e: any) {
    yield put(push('/verification-error'));
  }
}
function* resetPasswordRequestSaga(payload: any): any {
  try {
    const resetPassword = yield call(resetPasswordRequest, payload.payload);
    if (!resetPassword || resetPassword.error) {
      const errorType = resetPassword?.error?.type;
      if (errorType === 'RESET_PASSWORD_TOKEN_ALREADY_USED') {
        throw { type: errorType, detail: resetPassword.error.detail };
      }
      throw new Error('There has been an error reseting the password');
    } else {
      yield put(resetPasswordSuccessAction());
    }
  } catch (e: any) {
    const errorType = e?.type;
    if (errorType === 'RESET_PASSWORD_TOKEN_ALREADY_USED') {
      yield toast.error(i18n.t('translation:reset-pwd_token-used'));
    } else {
      yield toast.error(i18n.t('translation:recover-pwd_error'));
    }
    yield put(resetPasswordFailureAction(e));
  }
}
function* recoverPasswordRequestSaga(payload: any) {
  try {
    yield call(recoverPasswordRequest, payload.payload);
    yield toast.success(i18n.t('translation:recover-pwd_success_sent'));
    yield put(recoverPasswordSuccessAction(RecoverPassword));
  } catch (e: any) {
    yield toast.error(i18n.t('translation:recover-pwd_error_sent'));
    yield put(recoverPasswordFailureAction(e));
  }
}
function* refreshWalletRequestSaga() {
  try {
    const { wallet } = yield call(refreshWallet);
    yield put(refreshWalletSuccessAction(wallet));
  } catch (e: any) {
    yield put(refreshWalletFailureAction(e));
    toast.error(i18n.t('translation:coin-refresh_error'));
  }
}
function* getUserPremiumPlansRequestSaga(tipster_id: any) {
  try {
    const { user_premium_plans } = yield call(
      getUserPremiumPlans,
      tipster_id.payload,
    );
    yield put(getUserPremiumPlansSuccessAction(user_premium_plans));
  } catch (e: any) {
    yield put(getUserPremiumPlansFailureAction(e));
    //   toast.error(i18n.t('get-user-premium-plans_error'));
  }
}

function* verifySuccessSaga(payload: any) {
  yield put(push('/verification-success'));
}
function* meSaga() {
  yield takeEvery(VERIFY_REQUEST, verifyRequestSaga);
  yield takeEvery(RESET_PASSWORD_REQUEST, resetPasswordRequestSaga);
  yield takeEvery(RECOVER_PASSWORD_REQUEST, recoverPasswordRequestSaga);
  yield takeEvery(VERIFY_SUCCESS, verifySuccessSaga);
  yield takeEvery(REFRESH_WALLET_REQUEST, refreshWalletRequestSaga);
  yield takeEvery(USER_PREMIUM_PLANS_REQUEST, getUserPremiumPlansRequestSaga);
}

export default meSaga;
